import { Box, ButtonBase, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, IconButton, Stack, TextField, Typography, Zoom, useMediaQuery } from '@mui/material';
import React, { useEffect, useLayoutEffect, useState } from 'react'
import styled from 'styled-components';
import _ from 'lodash';
import { useTheme } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import ButtonStyled from '../../atoms/v2/Button';
import { useHistory } from 'react-router-dom';


const CheckoutSuccessDialog = (props: ICheckoutSuccessDialogProps) => {
    const { onClose, open, payload } = props;
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down(400));

    const history = useHistory();

    return (
        <BootstrapDialog
            open={open}
            fullWidth
            fullScreen={true}
            transitionDuration={0}
        >
            <DialogContent sx={{
                maxWidth: "400px",
                width: "100%",
                p: 2,
                boxSizing: "border-box",
                alignSelf: 'center'
            }}>
                <Stack spacing={5}>
                    <Stack spacing={2}>
                        <Typography
                            variant='h5'
                            textAlign='center'
                            fontWeight={500}
                            color='#32b0ea'>
                            Transacción exitosa
                        </Typography>
                        {payload !== undefined && (
                            <Typography
                                variant='body1'
                                textAlign='center'>
                                El curso está activado
                            </Typography>
                        )}
                    </Stack>
                    {payload === undefined && (
                        <>
                            <Typography
                                variant='body1'
                                textAlign='center'>
                                Ocurrió un problema al crear tu cuenta. Comunícate con nosotros para una solución
                            </Typography>
                            <Stack spacing={1}>
                                <Typography
                                    variant='subtitle1'
                                    textAlign='left'
                                    fontWeight={500}>
                                    Número de contacto
                                </Typography>
                                <Typography
                                    variant='body1'
                                    textAlign='left'>
                                    +51 975 400 190
                                </Typography>
                            </Stack>
                            <Stack spacing={1}>
                                <Typography
                                    variant='subtitle1'
                                    textAlign='left'
                                    fontWeight={500}>
                                    Correo de contacto
                                </Typography>
                                <Typography
                                    variant='body1'
                                    textAlign='left'>
                                    RaDi-languages@t-online.de
                                </Typography>
                            </Stack>
                        </>
                    )}
                    {payload !== undefined && (
                        <>
                            <Stack spacing={2}>
                                <Typography
                                    variant='h6'
                                    textAlign='left'
                                    fontWeight={500}>
                                    Correo
                                </Typography>
                                <Typography
                                    variant='body1'
                                    textAlign='left'>
                                    {payload.email}
                                </Typography>
                            </Stack>
                            {payload.password !== undefined && (
                                <Stack spacing={2}>
                                    <Typography
                                        variant='h6'
                                        textAlign='left'
                                        fontWeight={500}>
                                        Contraseña
                                    </Typography>
                                    <Typography
                                        variant='body1'
                                        textAlign='left'>
                                        {payload.password}
                                    </Typography>
                                </Stack>
                            )}
                        </>
                    )}
                    {props.courseId !== undefined && payload !== undefined && (
                        <ButtonStyled onClick={() => {
                            history.push(`/${props.courseId}`);
                        }}>
                            Ir al curso
                        </ButtonStyled>
                    )}
                </Stack>
            </DialogContent>
        </BootstrapDialog>
    );
}



const BootstrapDialog = styled(Dialog)(() => ({
    '& .MuiDialog-paper': {
        borderRadius: 20,
        maxWidth: 350
    },

    '& .MuiDialog-paperFullScreen': {
        borderRadius: 0,
        maxWidth: '100%'
    }
}));

const IconButtonStyled = styled(IconButton)({
    '&.MuiIconButton-root': {
        borderRadius: 15,
        borderWidth: 1,
        borderColor: '#32b0ea',
        borderStyle: 'solid'
    }
})

export { CheckoutSuccessDialog }